import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/users/user6.jpg'
import _imports_1 from '@/assets/images/products/product1.jpg'
import _imports_2 from '@/assets/images/users/user7.jpg'
import _imports_3 from '@/assets/images/products/product2.jpg'
import _imports_4 from '@/assets/images/users/user8.jpg'
import _imports_5 from '@/assets/images/products/product3.jpg'
import _imports_6 from '@/assets/images/users/user9.jpg'
import _imports_7 from '@/assets/images/products/product4.jpg'
import _imports_8 from '@/assets/images/users/user10.jpg'
import _imports_9 from '@/assets/images/products/product5.jpg'
import _imports_10 from '@/assets/images/users/user11.jpg'
import _imports_11 from '@/assets/images/users/user12.jpg'
import _imports_12 from '@/assets/images/users/user13.jpg'
import _imports_13 from '@/assets/images/users/user14.jpg'
import _imports_14 from '@/assets/images/users/user15.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_12 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_13 = { class: "flex items-center gap-[9px]" }
const _hoisted_14 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_15 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_16 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_17 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_20 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_21 = { class: "flex items-center gap-[9px]" }
const _hoisted_22 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_23 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_24 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_25 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_29 = { class: "flex items-center gap-[9px]" }
const _hoisted_30 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_31 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_32 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_33 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_36 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_37 = { class: "flex items-center gap-[9px]" }
const _hoisted_38 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_39 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_40 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_41 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_42 = { class: "flex items-center" }
const _hoisted_43 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_44 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_45 = { class: "flex items-center gap-[9px]" }
const _hoisted_46 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_47 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_48 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_49 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_50 = { class: "flex items-center" }
const _hoisted_51 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_52 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_53 = { class: "flex items-center gap-[9px]" }
const _hoisted_54 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_55 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_56 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_57 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_58 = { class: "flex items-center" }
const _hoisted_59 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_60 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_61 = { class: "flex items-center gap-[9px]" }
const _hoisted_62 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_63 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_64 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_65 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_66 = { class: "flex items-center" }
const _hoisted_67 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_68 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_69 = { class: "flex items-center gap-[9px]" }
const _hoisted_70 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_71 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_72 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_73 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_74 = { class: "flex items-center" }
const _hoisted_75 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_76 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_77 = { class: "flex items-center gap-[9px]" }
const _hoisted_78 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_79 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_80 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_81 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_82 = { class: "flex items-center" }
const _hoisted_83 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_84 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_85 = { class: "flex items-center gap-[9px]" }
const _hoisted_86 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_87 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_88 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"trezo-card-title\"><form class=\"relative sm:w-[265px]\"><label class=\"leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2\"><i class=\"material-symbols-outlined !text-[20px]\"> search </i></label><input type=\"text\" placeholder=\"Search review.....\" class=\"bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400\"></form></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" This Week "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Day </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Week </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Month </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[104] || (_cache[104] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " ID "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Reviewer "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Review "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Product "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Date "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Status "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }, " Action ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #999 ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Olivia Clark "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " olivia@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. ")
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Smart Band ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #998 ", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Zephyr Zing "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " zephyr@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-half-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ")
              ], -1)),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" Headphone ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 16 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 10:11 PM ")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_22, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_23, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_24, _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #997 ", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Nova Nectar "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " nova@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-line" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ")
              ], -1)),
              _createElementVNode("td", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode(" iPhone 15 Plus ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 15 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 11:11 AM ")
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_30, _cache[26] || (_cache[26] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_31, _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, _cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[39] || (_cache[39] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #996 ", -1)),
              _cache[40] || (_cache[40] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Isabella Chang "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " isabella@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-half-fill" }),
                  _createElementVNode("i", { class: "ri-star-line" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing. ")
              ], -1)),
              _createElementVNode("td", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode(" Bluetooth Speaker ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[43] || (_cache[43] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_38, _cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_39, _cache[37] || (_cache[37] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_40, _cache[38] || (_cache[38] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[49] || (_cache[49] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #995 ", -1)),
              _cache[50] || (_cache[50] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_8,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Alina Bennett "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " alina@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ")
              ], -1)),
              _createElementVNode("td", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode(" Airbuds 2nd Gen ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[53] || (_cache[53] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Published ")
              ], -1)),
              _createElementVNode("td", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_46, _cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_47, _cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_48, _cache[48] || (_cache[48] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[59] || (_cache[59] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #994 ", -1)),
              _cache[60] || (_cache[60] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Marcia Baker "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " marcia@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[61] || (_cache[61] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. ")
              ], -1)),
              _createElementVNode("td", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                        _createTextVNode(" Smart Band ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[62] || (_cache[62] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[63] || (_cache[63] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_54, _cache[56] || (_cache[56] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_55, _cache[57] || (_cache[57] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_56, _cache[58] || (_cache[58] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[69] || (_cache[69] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #993 ", -1)),
              _cache[70] || (_cache[70] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_11,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Carolyn Barnes "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " carolyn@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[71] || (_cache[71] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-half-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ")
              ], -1)),
              _createElementVNode("td", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _cache[65] || (_cache[65] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                        _createTextVNode(" Headphone ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[72] || (_cache[72] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 16 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 10:11 PM ")
              ], -1)),
              _cache[73] || (_cache[73] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_62, _cache[66] || (_cache[66] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_63, _cache[67] || (_cache[67] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_64, _cache[68] || (_cache[68] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[79] || (_cache[79] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #992 ", -1)),
              _cache[80] || (_cache[80] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Donna Miller "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " donna@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[81] || (_cache[81] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-line" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ")
              ], -1)),
              _createElementVNode("td", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[75] || (_cache[75] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[74] || (_cache[74] = [
                        _createTextVNode(" iPhone 15 Plus ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[82] || (_cache[82] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 15 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 11:11 AM ")
              ], -1)),
              _cache[83] || (_cache[83] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_70, _cache[76] || (_cache[76] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_71, _cache[77] || (_cache[77] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_72, _cache[78] || (_cache[78] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[89] || (_cache[89] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #991 ", -1)),
              _cache[90] || (_cache[90] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_13,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Barbara Cross "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " barbara@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[91] || (_cache[91] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-half-fill" }),
                  _createElementVNode("i", { class: "ri-star-line" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing. ")
              ], -1)),
              _createElementVNode("td", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _cache[85] || (_cache[85] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_75, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[84] || (_cache[84] = [
                        _createTextVNode(" Bluetooth Speaker ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[92] || (_cache[92] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[93] || (_cache[93] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _createElementVNode("td", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_78, _cache[86] || (_cache[86] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_79, _cache[87] || (_cache[87] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_80, _cache[88] || (_cache[88] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[99] || (_cache[99] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, " #990 ", -1)),
              _cache[100] || (_cache[100] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px] rounded-full" }, [
                    _createElementVNode("img", {
                      src: _imports_14,
                      class: "inline-block rounded-full",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Rebecca Block "),
                    _createElementVNode("span", { class: "block mt-[2px] text-gray-500 dark:text-gray-400" }, " rebecca@clickai.live ")
                  ])
                ])
              ], -1)),
              _cache[101] || (_cache[101] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("div", { class: "leading-none flex items-center gap-[2px] text-lg text-[#ee8336]" }, [
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" }),
                  _createElementVNode("i", { class: "ri-star-fill" })
                ]),
                _createElementVNode("p", { class: "mt-[10px] w-[350px]" }, " It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ")
              ], -1)),
              _createElementVNode("td", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _cache[95] || (_cache[95] = _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "block font-medium md:text-[15px] transition-all hover:text-primary-500"
                    }, {
                      default: _withCtx(() => _cache[94] || (_cache[94] = [
                        _createTextVNode(" Airbuds 2nd Gen ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _cache[102] || (_cache[102] = _createElementVNode("td", { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "block" }, " 17 Dec 2024 "),
                _createElementVNode("span", { class: "block" }, " 08:30 PM ")
              ], -1)),
              _cache[103] || (_cache[103] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Published ")
              ], -1)),
              _createElementVNode("td", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_86, _cache[96] || (_cache[96] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " download_done ", -1)
                  ]))), [
                    [_directive_tooltip, 'Approve']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_87, _cache[97] || (_cache[97] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " reply ", -1)
                  ]))), [
                    [_directive_tooltip, 'Reply']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_88, _cache[98] || (_cache[98] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "10",
        total: "36",
        class: "px-[20px] py-[12px] md:py-[14px] rounded-b-md border-l border-r border-b border-gray-100 dark:border-[#172036]"
      })
    ])
  ]))
}